export default "__VITE_ASSET__e4e437a4__"